import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "What is the recovery time after laparoscopic surgery?",
    a: "Recovery after laparoscopic surgery is significantly faster than traditional open surgery. Most patients can return to normal daily activities within 1-2 weeks, and full recovery including exercise and heavy lifting takes about 4-6 weeks. Each case is different, and Dr. Dileep will provide specific guidelines based on your procedure."
  },
  {
    q: "Is laser surgery for piles painful?",
    a: "Laser treatment for piles is virtually painless. The procedure is performed under local or spinal anesthesia, and patients experience only mild discomfort for 1-2 days after the procedure. Most patients can return to work within 2-3 days. This is a major improvement over traditional surgery which could involve significant pain for 2-3 weeks."
  },
  {
    q: "How should I prepare for hernia surgery?",
    a: "Before hernia surgery, you should: Fast for 8-12 hours before the procedure, stop blood-thinning medications as advised by Dr. Dileep, inform the doctor about all medications you're taking, arrange for someone to drive you home, and wear comfortable, loose-fitting clothing. A detailed pre-operative checklist will be provided during your consultation."
  },
  {
    q: "What are the advantages of laparoscopic surgery over open surgery?",
    a: "Laparoscopic surgery offers several advantages: smaller incisions (5-12mm vs 15-20cm), less post-operative pain, shorter hospital stay (often same-day discharge), faster recovery (1-2 weeks vs 4-6 weeks), lower risk of wound infection, better cosmetic results with minimal scarring, and improved visualization for the surgeon."
  },
  {
    q: "How do I know if I need gallbladder surgery?",
    a: "Gallbladder surgery is typically recommended when you have symptomatic gallstones causing recurrent pain attacks, inflammation of the gallbladder (cholecystitis), gallstones blocking the bile duct, or gallbladder polyps larger than 10mm. If you experience sudden upper right abdominal pain especially after fatty meals, it's important to consult Dr. Dileep for evaluation."
  },
  {
    q: "Is endoscopy safe? Will I be awake during the procedure?",
    a: "Endoscopy is a very safe and routine procedure. You will be given mild sedation (conscious sedation) which makes you relaxed and drowsy. Most patients don't remember the procedure afterward. The entire process takes only 10-15 minutes, and you can go home after resting for 1-2 hours."
  },
  {
    q: "What insurance plans are accepted?",
    a: "Both Kamineni Hospitals and Divi Multi Speciality Surgical Clinic work with most major insurance providers. It's best to call our office directly with your insurance details so we can verify coverage for your specific procedure. Our team will assist with insurance paperwork and pre-authorization."
  },
  {
    q: "Can I consult Dr. Dileep for a second opinion?",
    a: "Absolutely. Dr. Dileep welcomes second opinions and believes every patient deserves to make fully informed decisions about their healthcare. You can book a consultation at either of our two locations to discuss your condition and explore all available treatment options."
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl">
        <div className="text-center mb-12">
          <p className="reveal text-teal font-medium text-sm uppercase tracking-widest mb-3">FAQ</p>
          <h2 className="reveal delay-1 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className={`reveal delay-${Math.min(i + 1, 4)} bg-clinical rounded-xl border border-slate-100 px-5`}
            >
              <AccordionTrigger className="text-left font-heading font-semibold text-navy text-sm md:text-base py-4 hover:no-underline hover:text-teal">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-4">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
